import { configsDefaults } from "./state";

/**
 * Re establecer la configuración de etiquetas a su estado inicial.
 * 
 * @param Object state 
 */
export function resetProductLabelConfigs(state) {
    state.productLabelConfigs = configsDefaults();
}


/**
 * Establecer la configuración de etiquetas asociada al producto.
 * 
 * @param Object state 
 * @param Object nextState 
 */
export function setProductLabelConfigs(state, nextState) {
    state.productLabelConfigs = nextState;
}